import { IReduxStore } from 'Redux/Store/IReduxStore';

export const getWindowMode = (state: IReduxStore) => state.global.currentWindowMode;
